import { __decorate } from "tslib";
import { Table, Icon } from "ant-design-vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { ApplicationViews, DegreeType, CurriculumType } from "@/util/enum";
import { ReportsModule } from "@/modules/reports-objective";
import { ObjectiveService } from "@/services/objective-manager";
import { deepClone, pureRichText } from "@/util/func";
import UnitDegree from "../../components/unit-degree/unit-degree";
import ColumnTitle from "../../components/column-title/column-title.vue";
import { fmtMsg } from "commonui";
import MatIcon from "@/commonui/components/mat-icon/mat-icon";
import { ReportsLocale } from "@/locales/localeid";
import BasicIcon from "@/style/svgs/basic.svg";
import ExpertIcon from "@/style/svgs/expert.svg";
import MiddleIcon from "@/style/svgs/middle.svg";
import { VersionGroupModule } from "@/modules/versiongroup";
import { isUndefined } from "lodash";
const objectiveNumberColumnDataIndex = "objectiveNumber";
let ScopeSequence = class ScopeSequence extends Vue {
    constructor() {
        super(...arguments);
        this.versionGroupModule = VersionGroupModule;
        this.ReportsModule = ReportsModule;
        this.view = ApplicationViews.ScopeSequence;
        this.tableNodes = [];
        this.expandedKeys = [];
        this.level12Keys = [];
        this.level3Keys = [];
        this.DegreeType = DegreeType;
        this.unitRange = 0;
        this.columns = [];
        this.level3 = 3;
        this.level4 = 4;
        this.fixedColumns = [
            {
                className: "title-column",
                scopedSlots: { customRender: "titleName", title: "headerText" },
                width: 400
            }
        ];
        this.footerColumns = [
            {
                className: "first-column",
                dataIndex: "first",
                width: "25%",
                scopedSlots: { title: "firstHeader" }
            },
            {
                className: "second-column",
                dataIndex: "second",
                width: "25%",
                scopedSlots: { title: "basicDegree" }
            },
            {
                className: "third-column",
                dataIndex: "third",
                width: "25%",
                scopedSlots: { title: "middleDegree" }
            },
            {
                className: "fourth-column",
                dataIndex: "fourth",
                width: "25%",
                scopedSlots: { title: "expertDegree" }
            }
        ];
    }
    get vcsUnits() {
        return ReportsModule.vcsUnits;
    }
    get isShowObjective() {
        return ReportsModule.isShowObjective;
    }
    get isShowObjectiveNumber() {
        return ReportsModule.isShowObjectiveNumber;
    }
    get tableWidth() {
        const element = document.getElementsByClassName("ant-table")[0];
        return element.clientWidth - 20;
    }
    get startUnitText() {
        return this.getUnitTextById(this.UnitObject.startUnitId);
    }
    get endUnitText() {
        return this.getUnitTextById(this.UnitObject.endUnitId);
    }
    get basicComp() {
        return BasicIcon;
    }
    get middleComp() {
        return MiddleIcon;
    }
    get expertComp() {
        return ExpertIcon;
    }
    get loading() {
        return ReportsModule.isLoading;
    }
    get treeNodes() {
        return ReportsModule.objectivesTree;
    }
    get footerData() {
        return [
            {
                first: fmtMsg(ReportsLocale.ReportsFooterFirstColumnText),
                second: fmtMsg(ReportsLocale.ReportsFooterSecondColumnText),
                third: fmtMsg(ReportsLocale.ReportsFooterThirdColumnText),
                fourth: fmtMsg(ReportsLocale.ReportsFooterFourthColumnText)
            }
        ];
    }
    getExtraColumn(i, title) {
        const dataIndex = `unitColumn-${title}`;
        return {
            width: 30,
            title: title,
            key: dataIndex,
            dataIndex: dataIndex,
            className: "unit-column",
            customRender: (value, row) => {
                if (row.level === 1 || row.level === 2) {
                    // obj.attrs.rowSpan = 0;
                    return {
                        children: row,
                        attrs: {
                            colSpan: i == 1 ? this.unitRange : 0
                        }
                    };
                }
                else if (row.level === 3) {
                    row.unitObjective.map((u) => {
                        u.unit = this.getUnitTextById(u.unitId);
                    });
                    const degree = row.unitObjective.find((u) => u.unit === title)?.degree;
                    return {
                        children: <UnitDegree recorder={row} degree={degree}></UnitDegree>,
                        attrs: {
                            style: this.getCellClassStyle(degree)
                        }
                    };
                }
                else if (row.level === 4) {
                    const isUnitObjective = row.unitObjective.some((u) => this.getUnitTextById(u.unitId) === title);
                    return {
                        children: isUnitObjective ? (<div class="check">
								<MatIcon type="done"></MatIcon>
							</div>) : null
                    };
                }
            }
        };
    }
    getCellClassStyle(degree) {
        switch (degree) {
            case DegreeType.Basic:
                return "background-color: #f2f2f2;";
            case DegreeType.Intermediate:
                return "background-color: #e6e6e6;";
            case DegreeType.Expert:
                return "background-color:  #d9d9d9;";
            default:
                return "";
        }
    }
    get UnitObject() {
        return ReportsModule.unitObject;
    }
    setLoading(isLoading) {
        ReportsModule.setLoading(isLoading);
    }
    getRowClassName(record, index) {
        return `row-level-${record.level}`;
    }
    onVersionGroupChange() {
        this.copyData = null;
    }
    treeLevelInitial() {
        this.expandedKeys = this.isShowObjective ? this.level3Keys.concat(this.level12Keys) : this.level12Keys;
    }
    addRemoveNumberColumn() {
        const numberColumnIndex = this.columns.findIndex((c) => !isUndefined(c.colName) && c.colName === objectiveNumberColumnDataIndex);
        if (this.isShowObjectiveNumber && numberColumnIndex === -1) {
            const objectiveNumberColumn = {
                colName: objectiveNumberColumnDataIndex,
                className: "objective-number-column",
                width: "90px",
                scopedSlots: { customRender: "objectiveNumberSlot" }
            };
            this.columns.splice(0, 0, objectiveNumberColumn);
        }
        else {
            this.columns.splice(numberColumnIndex, 1);
        }
    }
    getObjectives(values) {
        this.unitRange = Object.keys(values).length ? this.getUnitRange(values) : 0;
        if (!this.UnitObject.startUnitId || !this.UnitObject.endUnitId) {
            return;
        }
        if (this.copyData && this.copyData.length) {
            this.onDataLoaded({ children: deepClone(this.copyData) });
            return;
        }
        const { startUnitId, endUnitId } = this.getStartEndIds();
        const params = {
            startUnitId,
            endUnitId,
            getAll: true,
            versionGroupId: this.versionGroupModule.selectedGsVersion !== "-1"
                ? this.versionGroupModule.selectedGsVersion
                : this.versionGroupModule.selectedLsVersion
        };
        this.setLoading(true);
        ObjectiveService.getObjectivesTree(params).then((data) => {
            this.copyData = deepClone(data.children);
            this.onDataLoaded(data);
        });
    }
    onDataLoaded(data) {
        const selectedUnitIds = this.getInBetweenUnitIds();
        const treeNodes = this.formatTreeLevel(data.children, "", selectedUnitIds);
        this.ReportsModule.setObjectivesTree(treeNodes);
        this.treeLevelInitial();
        this.clearColumns();
        this.addColumsByUnitRange();
        this.setLoading(false);
    }
    clearColumns() {
        this.columns = [];
        this.addRemoveNumberColumn();
        this.columns = this.columns.concat(this.fixedColumns);
    }
    getUnitRange(unitObject) {
        if (Object.keys(unitObject).length) {
            return this.getUnitTextById(unitObject.endUnitId) - this.getUnitTextById(unitObject.startUnitId) + 1;
        }
        else {
            return 0;
        }
    }
    getUnitTextById(unitId) {
        return this.vcsUnits.find((u) => u.id == unitId)?.unit;
    }
    hasVcsLevelByUnit(unit) {
        return this.vcsUnits.find((u) => u.unit == unit);
    }
    addColumsByUnitRange() {
        for (var i = 0; i < this.unitRange; i++) {
            const unit = i + (Object.keys(this.UnitObject).length ? this.getUnitTextById(this.UnitObject.startUnitId) : 0);
            const hasUnit = this.hasVcsLevelByUnit(unit);
            hasUnit && this.columns.push(this.getExtraColumn(i, unit));
        }
    }
    treeLevelSequence(parentIndex, index) {
        if (parentIndex === "") {
            return `${parentIndex}${index + 1}`;
        }
        else {
            return `${parentIndex}.${index + 1}`;
        }
    }
    shouldDisplayItem(a, selectedUnitIds) {
        const isInUnit = a.unitObjective.some((u) => selectedUnitIds.includes(u.unitId));
        if (isInUnit) {
            return true;
        }
        else {
            if (a.children.length) {
                return a.children.some((c) => this.shouldDisplayItem(c, selectedUnitIds));
            }
            else {
                return false;
            }
        }
    }
    formatTreeLevel(array, parentIndex, selectedUnitIds) {
        return array
            .map((p, index) => {
            Object.assign(p, {
                key: p.id,
                title: p.text,
                text: pureRichText(p.text),
                show: false,
                objectiveNumber: this.treeLevelSequence(parentIndex, index),
                scopedSlots: { title: "titleName", objectiveNumber: "objectiveNumberSlot" }
            });
            if (p.level === 1 || p.level === 2) {
                this.level12Keys.push(p.key);
            }
            if (p.level === 3) {
                this.level3Keys.push(p.key);
            }
            if (p.children.length) {
                p.children = this.formatTreeLevel(p.children, p.objectiveNumber, selectedUnitIds);
            }
            return p;
        })
            .filter((a) => this.shouldDisplayItem(a, selectedUnitIds));
    }
    getInBetweenUnitIds() {
        const curriculumType = VersionGroupModule.selectedGsVersion !== "-1"
            ? CurriculumType.GrapeSEED
            : VersionGroupModule.selectedLsVersion !== "-1"
                ? CurriculumType.LittleSEED
                : -1;
        const units = this.ReportsModule.vcsUnits.filter((u) => u.curriculumType === curriculumType &&
            (u.id === this.UnitObject.startUnitId || u.id === this.UnitObject.endUnitId));
        const startUnit = units.find((u) => u.id === this.UnitObject.startUnitId);
        const endUnit = units.find((u) => u.id === this.UnitObject.endUnitId);
        const selectedUnits = this.ReportsModule.vcsUnits.filter((u) => u.curriculumType === curriculumType && u.unit >= startUnit?.unit && u.unit <= endUnit?.unit);
        return selectedUnits.map((u) => u.id);
    }
    getStartEndIds() {
        const curriculumType = VersionGroupModule.selectedGsVersion !== "-1"
            ? CurriculumType.GrapeSEED
            : VersionGroupModule.selectedLsVersion !== "-1"
                ? CurriculumType.LittleSEED
                : -1;
        const units = this.ReportsModule.vcsUnits.filter((u) => u.curriculumType === curriculumType);
        const minUnit = Math.min(...units.map((u) => u.unit));
        const maxUnit = Math.max(...units.map((u) => u.unit));
        const startUnitId = units.find((u) => u.unit === minUnit)?.id || 0;
        const endUnitId = units.find((u) => u.unit === maxUnit)?.id || 0;
        return { startUnitId, endUnitId };
    }
};
__decorate([
    Watch("versionGroupModule.selectedGsVersion", { immediate: true }),
    Watch("versionGroupModule.selectedLsVersion", { immediate: true })
], ScopeSequence.prototype, "onVersionGroupChange", null);
__decorate([
    Watch("isShowObjective")
], ScopeSequence.prototype, "treeLevelInitial", null);
__decorate([
    Watch("isShowObjectiveNumber")
], ScopeSequence.prototype, "addRemoveNumberColumn", null);
__decorate([
    Watch("UnitObject", { immediate: true })
], ScopeSequence.prototype, "getObjectives", null);
ScopeSequence = __decorate([
    Component({
        components: {
            Icon,
            Table,
            BasicIcon,
            MiddleIcon,
            ExpertIcon,
            ColumnTitle,
            UnitDegree,
            MatIcon
        }
    })
], ScopeSequence);
export default ScopeSequence;
